import { render, staticRenderFns } from "./CookiesBanner.vue?vue&type=template&id=61941f22"
import script from "./CookiesBanner.vue?vue&type=script&lang=js"
export * from "./CookiesBanner.vue?vue&type=script&lang=js"
import style0 from "./CookiesBanner.vue?vue&type=style&index=0&id=61941f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports